module.exports = __webpack_public_path__ + "static/img/7.33ef3471.jpg";